import React from 'react';
import BrandLogo from './BrandLogo';

function Footer() {
  return (
    <footer className="site-footer">
      <BrandLogo className="footer-logo" />
      <div className="footer-copy">
        <strong>South Eastern Bakery</strong>
        <span>Global Flatbreads</span>
        <span>Et nyt dansk bageribrand under udvikling</span>
      </div>
      <a href="#forside" className="back-to-top">Til toppen ↑</a>
    </footer>
  );
}

export default Footer;